/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3StackAdaptCreativeAdMappingStatus } from '../models/V3StackAdaptCreativeAdMappingStatus';
import { HttpFile } from '../http/http';

/**
* Tracks the historical association between a creative and a campaign ad in StackAdapt. This mapping is created when a creative is attached to a campaign and receives an ad_id from StackAdapt's API. Multiple mappings can exist for a single creative (one per campaign).
*/
export class V3StackAdaptCreativeAdMapping {
    /**
    * StackAdapt ad ID (ref_id) created when creative is attached to campaign. This is the ID returned by StackAdapt's upsertCampaign mutation.
    */
    'adId'?: string;
    /**
    * El Toro internal campaign ID
    */
    'campaignId'?: string;
    /**
    * Human-readable campaign name for reference
    */
    'campaignName'?: string;
    /**
    * StackAdapt's internal campaign ID
    */
    'externalCampaignId'?: string;
    /**
    * Timestamp when this ad mapping was first created (when creative was attached to campaign)
    */
    'createdAt'?: Date;
    /**
    * Timestamp when this ad mapping was last updated (e.g., status change, campaign redeployment)
    */
    'updatedAt'?: Date;
    'status'?: V3StackAdaptCreativeAdMappingStatus;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "adId",
            "baseName": "ad_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "campaignId",
            "baseName": "campaign_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "campaignName",
            "baseName": "campaign_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "externalCampaignId",
            "baseName": "external_campaign_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "created_at",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updated_at",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "V3StackAdaptCreativeAdMappingStatus",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptCreativeAdMapping.attributeTypeMap;
    }

    public constructor() {
    }
}

